/**
 * Fee type to cash adjustment backend categorization mapping
 * Used to categorize different fee types into their corresponding cash adjustment categories
 * for backend processing and data consistency
 */
export const FEE_TYPE_TO_CASH_ADJUSTMENT_MAPPING = {
  'Custodian Fee': 'Cash Adjustment - Cust. Fee',
  'Withholding Tax': 'Cash Adjustment - Tax',
  'P&L Adjustment': 'Cash Adjustment - P&L',
  Interest: 'Cash Adjustment - Interest',
  'Management Fee': 'Cash Adjustment - MGMT',
  'Income Adjustment': 'Cash Adjustment - Income',
  'Misc Charge': 'Cash Adjustment - Misc',
  'Performance Fee': 'Cash Adjustment - Perf. Fee',
} as const;

/**
 * Valid fee types extracted from mapping
 * Used for validation to ensure only recognized fee types are processed
 */
export const VALID_FEE_TYPES = Object.keys(
  FEE_TYPE_TO_CASH_ADJUSTMENT_MAPPING
) as readonly string[];
